export default "__VITE_ASSET__Di1NZ1g1__"